enum TrialBillingStatus {
  BILLED = 'BILLED',
  NON_BILLABLE = 'NON_BILLABLE',
  UNBILLED = 'UNBILLED',
}

export default TrialBillingStatus;
